import React, { useState } from "react";
import { toast } from "sonner";
import { Heart, Loader2 } from "lucide-react";
import {
  Dialog, DialogContent, DialogHeader, DialogTitle, DialogTrigger, DialogDescription,
} from "./ui/dialog";
import { startCheckout } from "../lib/payments";

const PRESETS = [25, 50, 100, 250];

export const DonateButton = ({ className = "btn-rust px-5 py-2 text-xs", label = "Support / Donate", testid = "donate-open" }) => {
  const [open, setOpen] = useState(false);
  const [amount, setAmount] = useState(50);
  const [custom, setCustom] = useState("");
  const [form, setForm] = useState({ name: "", email: "" });
  const [busy, setBusy] = useState(false);

  const effectiveAmount = custom ? parseFloat(custom) : amount;

  const donate = async (e) => {
    e.preventDefault();
    if (!effectiveAmount || effectiveAmount < 1) return toast.error("Please enter a valid amount");
    if (!form.email) return toast.error("Please enter your email");
    setBusy(true);
    try {
      await startCheckout({ kind: "donation", amount: effectiveAmount, name: form.name, email: form.email });
    } catch {
      toast.error("Could not start checkout. Please try again.");
      setBusy(false);
    }
  };

  return (
    <Dialog open={open} onOpenChange={setOpen}>
      <DialogTrigger asChild>
        <button className={className} data-testid={testid}>{label}</button>
      </DialogTrigger>
      <DialogContent className="bg-cream border-2 border-forest max-w-md" data-testid="donate-modal">
        <DialogHeader>
          <DialogTitle className="font-display text-3xl text-forest flex items-center gap-2">
            <Heart className="text-rust" size={24} /> Support Pak Fest
          </DialogTitle>
          <DialogDescription className="text-forest-light">
            Your donation helps keep Pak Fest 2026 free and family-friendly for the whole community.
          </DialogDescription>
        </DialogHeader>

        <form onSubmit={donate} className="space-y-5 mt-2">
          <div>
            <label className="field-label">Choose an amount (CAD)</label>
            <div className="grid grid-cols-4 gap-2 mt-1">
              {PRESETS.map((p) => (
                <button
                  type="button"
                  key={p}
                  onClick={() => { setAmount(p); setCustom(""); }}
                  className={`py-2 border-2 numeral text-2xl transition-colors ${!custom && amount === p ? "bg-forest text-cream border-forest" : "border-forest/40 text-forest"}`}
                  data-testid={`donate-amount-${p}`}
                >
                  ${p}
                </button>
              ))}
            </div>
          </div>

          <div>
            <label className="field-label">Or enter a custom amount</label>
            <input
              type="number" min="1" step="1" className="vintage-input mt-1"
              placeholder="e.g. 75" value={custom}
              onChange={(e) => setCustom(e.target.value)}
              data-testid="donate-custom"
            />
          </div>

          <div className="grid grid-cols-2 gap-3">
            <div>
              <label className="field-label">Name</label>
              <input className="vintage-input mt-1" value={form.name} onChange={(e) => setForm({ ...form, name: e.target.value })} data-testid="donate-name" />
            </div>
            <div>
              <label className="field-label">Email *</label>
              <input type="email" required className="vintage-input mt-1" value={form.email} onChange={(e) => setForm({ ...form, email: e.target.value })} data-testid="donate-email" />
            </div>
          </div>

          <button type="submit" disabled={busy} className="btn-rust w-full py-4 text-base disabled:opacity-60 flex items-center justify-center gap-2" data-testid="donate-submit">
            {busy ? <><Loader2 size={18} className="animate-spin" /> Redirecting…</> : `Donate $${effectiveAmount || 0} CAD`}
          </button>
          <p className="text-center text-xs text-forest-light/70">Secure card payment via Stripe.</p>
        </form>
      </DialogContent>
    </Dialog>
  );
};
